import { ExternallyAccessibleNostosV1NaptimeResource } from './__generated__/ExternallyAccessibleNostosV1';

class ExternallyAccessibleNostos extends ExternallyAccessibleNostosV1NaptimeResource {
  static RESOURCE_NAME = 'externallyAccessibleNostos.v1' as const;
}

export default ExternallyAccessibleNostos;
